
  import { CATEGORIES } from '@/constants/blog';
  import { mapGetters } from 'vuex';

  export default {
    props: {
      article: { type: Object, required: true }
    },
    data () {
      return {
        categories: CATEGORIES,
        icons: {
          banking: 'banking/loot',
          broadband: 'broadband/broadband',
          'gas-electricity': 'energy/energy',
          mortgage: 'mortgage/house',
          'personal-finance': 'banking/loot'
        },
        timeToRead: null
      };
    },
    computed: {
      ...mapGetters('user', { user: 'get' }),
      category () {
        return this.categories[this.$route.params.category];
      },
      tableOfContents () {
        return this.article.body
          ? Array.from(this.getH3Elements(this.article.body)).map(h3Element => h3Element.textContent.trim())
          : null;
      },
      iconName () {
        return this.icons[this.category.slug] || 'insurance/income';
      }
    },
    methods: {
      getH3Elements (htmlString) {
        if (process.client) {
          const tempElement = document.createElement('div');
          tempElement.innerHTML = htmlString;
          const h3Elements = tempElement.querySelectorAll('h3');
          const filteredH3Elements = Array.from(h3Elements).filter(h3Element => h3Element.textContent.trim().length);
          return filteredH3Elements;
        } else {
          return [];
        }
      },
      navigateToCategory () {
        this.$router.push(this.localePath(this.categories[this.article.category.title]));
      },
      scrollToHeader (text) {
        const h3Elements = document.querySelectorAll('.article-body h3');
        const targetElement = Array.from(h3Elements).find((element) =>
          element.textContent.trim() === text
        );
        if (targetElement) {
          this.$nextTick(() => {
            const scrollOffset = targetElement.offsetTop - 20; // Adjust the scroll padding value as needed
            window.scrollTo({ top: scrollOffset, behavior: 'smooth' });
          });
        }
      }
    }
  };
